import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
	},
	mutations: {
		lastPath(state,v) {
			state.lastPath = v
		}
	},
	actions: {
	},
	modules: {
	}
})
